/**
 * PaginaPrincipal - Página inicial de seleção de features
 *
 * CONTEXTO DE NEGÓCIO:
 * Página que apresenta as features principais da aplicação e permite
 * que o usuário navegue para a funcionalidade desejada (Análise Multi-Agent
 * ou Análise de Petição Inicial).
 *
 * ENTREGÁVEL (TAREFA-057):
 * - Layout centralizado com cards para cada feature
 * - Reutiliza `CardFeature` para consistência
 */

import React from 'react';
import { CardFeature } from '../componentes/CardFeature';
import { FileSearch, Users, Upload } from 'lucide-react';

/**
 * Componente da Página Principal
 *
 * IMPLEMENTAÇÃO:
 * - Grid responsivo com os cards de feature
 * - Títulos, descrições e links para as páginas existentes (/analise, /analise-peticao)
 */
export function PaginaPrincipal(): JSX.Element {
  return (
    <main className="mx-auto max-w-6xl px-4 py-12">
      <header className="mb-10 text-center">
        <h2 className="text-3xl font-bold text-gray-900">Bem-vindo à Plataforma Jurídica Multi-Agent</h2>
        <p className="mt-2 text-gray-600">Escolha uma feature para começar — análise de documentos ou análise de petição inicial com prognóstico.</p>
      </header>

      <section>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <CardFeature
            title="Análise Multi-Agent"
            description="Analise documentos jurídicos com múltiplos especialistas (advogados e peritos) e receba pareceres detalhados."
            icon={<Users className="size-6" />}
            to="/analise"
            actionLabel="Ir para Análise"
          />

          <CardFeature
            title="Análise Processual - Reclamada"
            description="Analise processos e obtenha prognóstico processual, próximos passos e documentos necessários."
            icon={<FileSearch className="size-6" />}
            to="/analise-peticao"
            actionLabel="Ir para Petição"
          />

          <CardFeature
            title="Criação de Petição Inicial - Reclamante"
            description="Crie sua petição inicial com assistência de IA, anexando documentos e preenchendo campos personalizados."
            icon={<Upload className="size-6" />}
            to="/criacao-peticao-inicial"
            actionLabel="Iniciar Criação"
          />
        </div>
      </section>
    </main>
  );
}

export default PaginaPrincipal;
